import Box from '@mui/material/Box'
import React from 'react'
import {CircularProgress} from '@mui/material'

type LoadingSpinnerProps = {
    message?: string
}

const LoadingSpinner = ({message = 'Loading...'}: LoadingSpinnerProps) => {
    return (
        <Box
            paddingTop="5em"
            bgcolor="#edf6f9"
            width="100%"
            alignItems="center"
            justifyContent="center"
            display="flex"
            flexDirection="column">
            <CircularProgress size="4em"/>
            <h2>{message}</h2>
        </Box>
    )
}

export default LoadingSpinner